import React from 'react';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';
import { MessageSquareTextIcon } from 'lucide-react';

import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';

import NpsResultsComments from './NpsCampaignResultsDialog/NpsResultsComments';

interface IProps {
  campaign: NpsCampaignDto;
  disabled?: boolean;
  disabledReason?: string;
}

const NpsCampaignCommentsDialog: React.FC<IProps> = ({
  campaign,
  disabled,
  disabledReason,
}) => (
  <Dialog
    title={`Comentários — ${campaign.name}`}
    description="Comentários anônimos enviados nesta campanha."
    className="sm:max-w-[850px]"
    tooltipContent={
      disabled
        ? (disabledReason ??
          'Os comentários desta campanha não estão disponíveis para o seu perfil.')
        : 'Ver comentários'
    }
    trigger={
      <Button
        variant="outline"
        size="icon-sm"
        disabled={disabled}
        aria-label={`Ver comentários de ${campaign.name}`}
      >
        <MessageSquareTextIcon data-icon="inline-start" />
      </Button>
    }
  >
    <NpsResultsComments campaignId={campaign.id} canViewComments={!disabled} />
  </Dialog>
);

export default NpsCampaignCommentsDialog;
